module.exports = __webpack_public_path__ + "img/loader.d0b274f0.gif";